<footer class="my-0.5 px-8">
    Dieses System wurde gebaut durch die Pottkinder GmbH. Informationen zur Rechtslage sind der <a href="https://www.pottkinder.de/">Webseite</a> zu entnehmen.
</footer>